<template>
  <pt-integral-exchange class="pt-integral-exchange__withData" v-loading="loading" :totalConsume="totalConsume" :balance="balance" @getIntegralTotalConsume="getIntegralTotalConsume"
  :goodsTypeList="goodsTypeList" :groupList="groupList"  @exportAllOrder="exportAllOrder" :exportLoading="exportLoading" :addressList="addressList" :allMembers="allMembers"></pt-integral-exchange>
</template>

<script>
import PtIntegralExchange from './index'
export default {
  name: 'pt-integral-exchange__withData',
  components: {
    'pt-integral-exchange': PtIntegralExchange
  },
  data () {
    return {
      loading: false,
      balance: '',
      totalConsume: '',
      goodsTypeList: [],
      groupList: [],
      exportLoading: false,
      addressList: [],
      allMembers: []
    }
  },
  methods: {
    // 导出订单
    exportAllOrder (val) {
      let data = {
        ...val,
        pageable: {
          sort: 'createdDate,desc'
        }
      }
      this.exportLoading = true
      this.$store.dispatch('getIntegralExportExcel', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出订单失败')
      })
    },
    getAreatList () {
      this.$store.dispatch('getBusinessArea').then(data => {
        let options = []
        data.forEach(item => {
          let signalItem = {
            label: item.name,
            value: item.value
          }
          options.push(signalItem)
        })
        this.addressList = options
      })
    },
    // 获取商品分组列表
    getGroupList () {
      let data = {
        pageable: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('integralGroupWithGoodsCount', data).then(res => {
        this.groupList = res.data
      }).catch(err => {
        this.$message.error(err || '获取商品分组失败')
      })
    },
    // 获取商品类型列表
    getGoodsTypes () {
      this.$store.dispatch('getIntergralGoodsTypesOfAll').then(res => {
        this.goodsTypeList = res
      }).catch(err => {
        this.$message.error(err || '获取商品类型列表失败')
      })
    },
    getIntegralTotalConsume (val) {
      let data = {}
      if (val) {
        data = val
      }
      this.$store.dispatch('getIntegralTotalConsume', data).then(res => {
        this.totalConsume = res.data
      }).catch(err => {
        this.$message(err || '获取事业部总额度失败')
      })
    },
    getAllMembers () {
      this.$store.dispatch('getAllMembers').then(res => {
        this.allMembers = res.data
      }).catch(err => {
        this.$message.error(err || '获取会员等级失败')
      })
    },
    load () {
      this.loading = true
      let promiseArr = [this.getGroupList(), this.getIntegralTotalConsume(), this.getGoodsTypes(), this.getAreatList(), this.getAllMembers()]
      Promise.all(promiseArr).then(_ => {
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.$message.error(err)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
